import adoption from '../../contracts/dohm/frozensave-monetization-adoption.v1.json';
import type { HouseholdSharingStatus } from '../application/household-sharing';
import {
  FROZEN_SAVE_MONETIZATION_APPLICATION_ID,
  FROZEN_SAVE_MONETIZATION_PRODUCT_ID,
  type FrozenSaveMonetizationActivation,
  type FrozenSaveMonetizationPort,
  type FrozenSaveMonetizationProfile,
  type FrozenSaveMonetizationProjection,
} from '../application/monetization';

const NATIVE_PRODUCT_SUBJECT = /^fsa_[A-Za-z0-9_-]{24,80}$/u;
const EXPECTED_PROFILES: readonly FrozenSaveMonetizationProfile[] = [
  'commercial-capable-disabled',
  'editorial-advertising-eligible-disabled',
];

const activation = adoption.realActivationFlags as FrozenSaveMonetizationActivation;

const assertDisabledAdoption = (): void => {
  if (
    adoption.productId !== FROZEN_SAVE_MONETIZATION_PRODUCT_ID ||
    adoption.nativeAccountAuthorityConfirmed !== true ||
    adoption.nativeAccountAuthority.dohmId !== 'optional-federation-only' ||
    adoption.nativeAccountAuthority.myDohm !== 'minimal-read-only-projection-only' ||
    adoption.profiles.length !== EXPECTED_PROFILES.length ||
    !EXPECTED_PROFILES.every((profile) => adoption.profiles.includes(profile)) ||
    Object.values(adoption.realActivationFlags).some((value) => value !== false)
  ) {
    throw new Error('MONETIZATION_ADOPTION_INVALID');
  }
};

assertDisabledAdoption();

/** Adaptateur volontairement sans transport : toutes les activations réelles restent fermées. */
export class DisabledMonetizationAdapter implements FrozenSaveMonetizationPort {
  readonly enabled = false as const;

  projection(status: HouseholdSharingStatus): FrozenSaveMonetizationProjection {
    const nativeAccount = status.state === 'connected'
      ? (() => {
          if (!NATIVE_PRODUCT_SUBJECT.test(status.productSubjectId)) {
            throw new Error('MONETIZATION_NATIVE_ACCOUNT_INVALID');
          }
          return {
            applicationId: FROZEN_SAVE_MONETIZATION_APPLICATION_ID,
            opaqueProductSubject: status.productSubjectId,
          } as const;
        })()
      : null;

    return {
      productId: FROZEN_SAVE_MONETIZATION_PRODUCT_ID,
      profiles: EXPECTED_PROFILES,
      accountAuthority: 'native-product-account',
      ledgerSubject: 'opaque-product-subject-scoped-by-application-id',
      dohmId: 'optional-federation-only',
      myDohm: 'minimal-read-only-access-and-promotion-projection-only',
      nativeAccount,
      activation: { ...activation },
    };
  }
}
